
<div class="modal fade" id="modalExperienciaLaboral" tabindex="-1" aria-labelledby="modalExperienciaLaboralLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalExperienciaLaboralLabel">Experiencia Laboral</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row" [formGroup]="form">
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Cargo desempeñado</label>
                            <div>
                                <app-dropdown [options]="positions" formControlName="positionId"></app-dropdown>
                                @if (form.get('positionId')?.invalid && (form.get('positionId')?.touched || form.get('positionId')?.dirty)) {
                                    @if (form.get('positionId')?.errors?.['required'] == true) {
                                        <div class="invalid-field">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Empresa</label>
                            <div>
                                <app-dropdown [options]="companies" formControlName="companyId"></app-dropdown>
                                @if (form.get('companyId')?.invalid && (form.get('companyId')?.touched || form.get('companyId')?.dirty)) {
                                    @if (form.get('companyId')?.errors?.['required'] == true) {
                                        <div class="invalid-field">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Desde</label>
                            <div>
                                <input formControlName="startDate" type="date" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('startDate')?.invalid && (form.get('startDate')?.touched || form.get('startDate')?.dirty)}"/>
                                @if (form.get('startDate')?.invalid && (form.get('startDate')?.touched || form.get('startDate')?.dirty)) {
                                    @if (form.get('startDate')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label [ngClass]="{'required-field': form.get('currentJob')?.value == false}">Hasta</label>
                            <div>
                                <input formControlName="endDate" type="date" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('endDate')?.invalid && (form.get('endDate')?.touched || form.get('endDate')?.dirty)}"/>
                                @if (form.get('endDate')?.invalid && (form.get('endDate')?.touched || form.get('endDate')?.dirty)) {
                                    @if (form.get('endDate')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label>Rango salarial</label>
                            <div>
                                <app-dropdown [options]="salaryExpectationOptions" formControlName="salaryExpectationId" [showSearch]="false"></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label>¿Trabajo actual?</label>
                            <div>
                                <div class="form-check form-check-inline">
                                    <input (change)="changeCurrentJob()" formControlName="currentJob" class="form-check-input" type="radio" name="currentJob" id="TrabajoActual1" [value]="true">
                                    <label class="form-check-label" for="TrabajoActual1">Si</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input (change)="changeCurrentJob()" formControlName="currentJob" class="form-check-input" type="radio" name="currentJob" id="TrabajoActual2" [value]="false">
                                    <label class="form-check-label" for="TrabajoActual2">No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label>Descripción de Responsabilidades</label>
                            <div>
                                <textarea  formControlName="responsibility" class="form-control" rows="3"
                                [ngClass]="{'is-invalid': form.get('responsibility')?.invalid && (form.get('responsibility')?.touched || form.get('responsibility')?.dirty)}"></textarea>
                                @if (form.get('responsibility')?.invalid && (form.get('responsibility')?.touched || form.get('responsibility')?.dirty)) {
                                    @if (form.get('responsibility')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                    @if (form.get('responsibility')?.hasError('maxlength')) {
                                        <div class="invalid-feedback">
                                            Este campo no puede exceder los {{form.get('responsibility')?.errors?.['maxlength']?.requiredLength}} caracteres
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button (click)="closeModal()" type="button" class="btn btn-secondary me-2">
                        Cancelar
                    </button>
                    <button (click)="submit()" type="button" class="btn btn-primary">
                        @if(!isLoading()){
                            Guardar
                        }@else {
                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Guardando
                        }
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>